import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'fileType',
})
export class FileTypePipe implements PipeTransform {
	transform(filename: string): string {
		if (!filename) return 'fa fa-file-o'; // Default icon for unknown file

		// Extract file extension from filename
		const parts = filename.split('.');
		const extension = parts.length > 0 ? parts[parts.length - 1].toLowerCase() : '';
		console.log('extension ', extension);

		// Map file extensions to Font Awesome icons
		switch (extension) {
			// Documents
			case 'pdf':
				return 'fa fa-file-pdf-o';
			case 'doc':
			case 'docx':
				return 'fa fa-file-word-o';
			case 'xls':
			case 'xlsx':
			case 'csv':
				return 'fa fa-file-excel-o';
			case 'ppt':
			case 'pptx':
				return 'fa fa-file-powerpoint-o';
			case 'txt':
				return 'fa fa-file-text-o';

			// Images
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
			case 'bmp':
			case 'svg':
				return 'fa fa-file-image-o';

			// Default
			default:
				return 'fa fa-file-o';
		}
	}
}
